import { render, staticRenderFns } from "./PointManage.vue?vue&type=template&id=096d5e93&scoped=true&lang=pug&"
import script from "./PointManage.vue?vue&type=script&lang=js&"
export * from "./PointManage.vue?vue&type=script&lang=js&"
import style0 from "./PointManage.vue?vue&type=style&index=0&id=096d5e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d5e93",
  null
  
)

export default component.exports